import { submit, change } from 'redux-form';
import {
  SET_FORM,
  SET_LOADING,
  SET_AGREE_TNC,
  SET_FORM_DATA,
} from 'redux/actions/types';
import apiService from '../../utils/ApiService';

const { billerService } = apiService.getInstance();

export const setLoading = isLoading => ({
  type: SET_LOADING,
  payload: isLoading,
});

export const setForm = data => ({
  type: SET_FORM,
  payload: data,
});

export const setFormData = data => ({
  type: SET_FORM_DATA,
  payload: data,
});

export const setFormDataValue = data => dispatch => {
  dispatch(setFormData(data));
};

export const submitButtonButton = () => dispatch => {
  dispatch(submit('allBiller'));
};

export const updateFieldForm = (fieldName, value) => dispatch => {
  dispatch(change('allBiller', fieldName, value));
};

export const getForm = id => async dispatch => {
  let resolve = null;
  try {
    dispatch(setLoading(true));
    const response = await billerService.get(`forms/${id}`);
    resolve = response;
    if (response.status === 200) {
      dispatch(setForm({}));
      const { payload } = response.data;
      dispatch(setForm(payload));
    } else {
      dispatch(setForm({}));
    }
    dispatch(setLoading(false));
  } catch (error) {
    resolve = error;
    dispatch(setForm({}));
    dispatch(setLoading(false));
  }
  return resolve;
};

export const setAgreeTnc = () => ({
  type: SET_AGREE_TNC,
});
